import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { CurrencyPipe } from '@frontend/sports/common/core/feature/money';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { DsCheckbox } from '@frontend/ui/checkbox';
import { DsRadioModule } from '@frontend/ui/radio-button';
import { NativeAppService } from '@frontend/vanilla/core';

import { Tracking, WalletPersistenceType, WalletType } from '../account-balance.models';
import { AccountBalanceService } from '../account-balance.service';
import { WalletStoreService } from '../wallet-store.service';

@Component({
    selector: 'ms-wallet-selector',
    templateUrl: './wallet-selector.component.html',
    imports: [FormsModule, AsyncPipe, CurrencyPipe, DsCheckbox, DsRadioModule],
})
export class WalletSelectorComponent implements OnInit {
    selectedWalletType: WalletType;
    doNotShowAgain = false;
    walletSelectorHelpUrl: string;

    @Input() inColumn = false;

    constructor(
        public sitecore: Sitecore,
        public accountBalanceService: AccountBalanceService,
        private walletStoreService: WalletStoreService,
        private activeModal: ActiveModal,
        private tracker: TrackingService,
        public nativeAppService: NativeAppService,
    ) {
        if (sitecore.betslip.links.help.walletselectorhelp && sitecore.betslip.links.help.walletselectorhelp.url) {
            this.walletSelectorHelpUrl = sitecore.betslip.links.help.walletselectorhelp.url;
        }
    }

    ngOnInit(): void {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.selectedWalletType = this.accountBalanceService.selectedWallet!.type;

        this.trackWalletSelectorDialog({
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Wallet Interceptor - Loaded',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'Choose Wallet Interceptor is loaded',
            [trackingConstants.COMPONENT_POSITION_EVENT]: Tracking.NotApplicable,
        });
    }

    save(): void {
        const persistenceType = this.doNotShowAgain ? WalletPersistenceType.Permanent : WalletPersistenceType.Temporary;
        this.accountBalanceService.selectWallet(this.selectedWalletType, persistenceType);
        this.walletStoreService.walletSelectorIsShown = true;
        this.activeModal.close();

        this.trackWalletSelectorDialog({
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Wallet  - Selected',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'Confirm CTA - Clicked',
            [trackingConstants.COMPONENT_EVENT_DETAILS]:
                this.selectedWalletType === WalletType.Main ? 'Main Balance - Selected' : 'PayPal Balance - Selected',
        });

        if (this.doNotShowAgain) {
            this.trackWalletSelectorDialog({
                [trackingConstants.COMPONENT_ACTION_EVENT]: 'Don’t Show This Again - Clicked',
                [trackingConstants.COMPONENT_EVENT_DETAILS]: 'Don’t Show This Again - Clicked',
                [trackingConstants.COMPONENT_POSITION_EVENT]: Tracking.NotApplicable,
            });
        }
    }

    private trackWalletSelectorDialog(additionalTrackData: Partial<TrackData>): void {
        const baseTrackData = {
            [trackingConstants.PAGE_SITE_SECTION]: Tracking.SportsSiteSection,
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: Tracking.Wallets,
            [trackingConstants.COMPONENT_LABEL_EVENT]: Tracking.DialogSelectorLabelEvent,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.inColumn ? Tracking.Desktop : Tracking.Mobile,
            [trackingConstants.COMPONENT_URL_CLICKED]: Tracking.NotApplicable,
        };
        const fullTrackData = { ...baseTrackData, ...additionalTrackData };

        this.tracker.track(trackingConstants.EVENT_TRACKING, fullTrackData);
    }
}
